import * as _ from "lodash"

import {
  ISearch,
  ISearchProfile,
  ISearchProvider,
  HorizAlignment,
  SearchProviderFieldType,
  ISearchProviderField, ISearchRequestSubset, ITree, IProfileFilter, ISearchSort
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";

import {WB_CustomerRow} from "../PA.Core/PAdbSchemaRows";
import {ASync} from "../PA.Core/Basic/ASync";


const vWB_Cust_Fields: {[id:string]: ISearchProviderField } = {
  WB_CUST_ID:             {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Customer WB Id',  columnResourceName: 'colCustWBId',      alignment: HorizAlignment.Center}, domainOptions: { }},
  CUSTOMER_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Id',     columnResourceName: 'colCustId',        alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
  CUSTOMER_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Name',   columnResourceName: 'colCustName',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
  CUSTOMER_TYPE:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Level',           columnResourceName: 'colLevel',         alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
  CONSUMPTION_IND:        {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Cons Ind',        columnResourceName: 'colConsInd',       alignment: HorizAlignment.Center}, domainOptions: { maxLength: 5}},
  SHIPMENT_IND:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Ship Ind',        columnResourceName: 'colShipInd',       alignment: HorizAlignment.Center}, domainOptions: { maxLength: 5}},
  PLANNING_CUSTOMER_IND:  {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Planning Ind',    columnResourceName: 'colPlanInd',       alignment: HorizAlignment.Center}, domainOptions: { maxLength: 5}},
  PLANNED_PERIODS:        {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Planned Periods', columnResourceName: 'colPlannedPeriod', alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
  SOURCE_ID:              {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Source Id',       columnResourceName: 'colSourceId',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
  TREE_PATH:              {type: SearchProviderFieldType.string, renderOptions:  { columnName: 'Tree Path',      columnResourceName: 'colTreePath',     alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}}
}

const vWB_Customer_KeyFields =
  {id:    'WB_CUST_ID',
   id_ui: 'CUSTOMER_ID',
   name:  'CUSTOMER_NAME'}


class CustomerSearchByListSearchProvider
  implements  ISearchProvider {

  arrWB_CustomerRows:WB_CustomerRow[] = []

  constructor(WB_CustomerRows: WB_CustomerRow[]){
    this.arrWB_CustomerRows = WB_CustomerRows
  }

  get keyFields() { return vWB_Customer_KeyFields }

  get searchProviderFields(){
    return vWB_Cust_Fields
  }

  search(requestSpec: ISearchRequestSubset): Promise<any[]> {
    return ASync.resolve(_.map(this.arrWB_CustomerRows, (aWB_CustRow: WB_CustomerRow) => {
      return aWB_CustRow.toJSON()
    }))
  }

}


class CustomerSearchByListSearchProfile
  implements  ISearchProfile {

  aSearchProvider: ISearchProvider = undefined

  profileId = "default"
  profileName = "AutoSearch Only"
  renderOptions = { ui5ResourceId: "CustomerSearchByListProfile" }

  profileFilter: IProfileFilter[] = []

  profileDisplayFields = [
    'CUSTOMER_NAME','CUSTOMER_ID', 'CUSTOMER_TYPE'
  ]

  profileTreeIdDefault = "default"
  profileTrees: ITree[] = [
    {treeId: "default",
      treeName: "By Hierarchy",
      nodeProviders: [ new ColumnNodeProvider(['TREE_PATH'], {defaultValues: "No Customer Tree Path Set", levelDelimiter: "\\", ruggedTree: true})],
      renderOptions: {}}
  ]

  // Do sorting last.. not necessary for phase 1
  profileSortIdDefault = ""    //string;
  profileSorts: ISearchSort[] = [] //ISearchSort[];


  constructor(WB_CustomerRows: WB_CustomerRow[]){
    this.aSearchProvider = new CustomerSearchByListSearchProvider(WB_CustomerRows)
  }

  get profileSearchProvider(){ return this.aSearchProvider }

}


export class CustomerSearchByList
  implements  ISearch {

  constructor(WB_CustomerRows: WB_CustomerRow[], options?: any){
    this.searchProfiles = [ new CustomerSearchByListSearchProfile(WB_CustomerRows) ]
  }

  searchName = "Select Customer(s)"
  renderOptions = { ui5ResourceId: "CustomerSearchByList"}
  searchProfileIdDefault = "default"
  searchProfiles: ISearchProfile[] = []
  autoSearch = true

}
